import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { QuickServices } from '../components/QuickServices';
import { MinisterWelcome } from '../components/MinisterWelcome';
import { UserPathways } from '../components/UserPathways';
import { StatsSection } from '../components/StatsSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { NewsSection } from '../components/NewsSection';
import { KnowledgeHub } from '../components/KnowledgeHub';
import { Footer } from '../components/Footer';
import { WeatherWidget } from '../components/WeatherWidget';
import { ChatBot } from '../components/ChatBot';
export function Home() {
  return <>
      <Header data-id="element-844" />
      <main className="flex-grow pt-[160px] md:pt-[148px]" data-id="element-845">
        <HeroSection data-id="element-846" />
        <QuickServices data-id="element-847" />
        <MinisterWelcome data-id="element-848" />
        <UserPathways data-id="element-849" />
        <StatsSection data-id="element-850" />
        <ProgramsSection data-id="element-851" />
        <ProjectsSection data-id="element-852" />
        <NewsSection data-id="element-853" />
        <KnowledgeHub data-id="element-854" />
      </main>
      <Footer data-id="element-855" />
      <WeatherWidget data-id="element-856" />
      <ChatBot data-id="element-857" />
    </>;
}